import React, { useCallback, useEffect } from 'react'
import {
  useNavigate,
  useSearchParams,
  NavigateFunction,
} from 'react-router-dom'

import { t } from '@/i18n'
import { IBreadcrumb } from '@/types'
import { AppLayout, Breadcrumbs, LanguageSelector } from '@/components'
import { homePath, makeSearchPath, dealsPath } from '@/utils/index'
import { IDeal } from '@/types'
import Form from './form'
import { useData } from './useData'
import DealAlreadyExistsForProposalModal from '@/pages/Deal/DealAlreadyExistsForProposalModal'
import useIsOpen from '@/hooks/useIsOpen'

const breadcrumbs: IBreadcrumb[] = [
  {
    name: 'search',
    path: homePath,
  },
  {
    name: 'add_deal',
  },
]

const AddDeal: React.FC = () => {
  const navigate: NavigateFunction = useNavigate()
  const [searchParams] = useSearchParams()

  const {
    isOpen: isDealAlreadyExistsModalOpen,
    open: openDealAlreadyExistsModal,
    close: closeDealAlreadyExistsModal,
  } = useIsOpen()

  const proposalId = searchParams.get('proposal')
  const { data, loading, submitting, onCancel, onSubmit } = useData({
    proposalId: proposalId ?? '',
  })

  useEffect(() => {
    if (data && data.hasDeal) {
      openDealAlreadyExistsModal()
    }
  }, [data])

  const onSubmitForm = useCallback(
    (d: IDeal) => {
      onSubmit('deals/deals/', false, res => {
        const viewPath = makeSearchPath(dealsPath, {
          customerId: 'customer',
          id: res.id,
        })
        navigate(viewPath)
      })(d)
    },
    [navigate, onSubmit],
  )

  return (
    <AppLayout
      hasFooter
      headerRight={
        <div className="app-right-container">
          <LanguageSelector />
        </div>
      }
    >
      <DealAlreadyExistsForProposalModal
        isOpen={isDealAlreadyExistsModalOpen}
        onClose={closeDealAlreadyExistsModal}
      />
      <Breadcrumbs breadcrumbs={breadcrumbs} />
      <div className="page-container">
        <div className="container">
          <div className="page-content">
            <div className="content-box">
              <div className="scroll-wrap">
                <div className="content-title">
                  <h2>{t('add_deal')}</h2>
                </div>
                <Form
                  isEditing
                  loading={loading}
                  submitting={submitting}
                  initialData={data}
                  onCancel={onCancel}
                  onSubmit={onSubmitForm}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </AppLayout>
  )
}

export default AddDeal
